import React from 'react';
import PropTypes from 'prop-types';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import cx from 'classnames';
import { flattenToAppURL, isInternalURL } from '@plone/volto/helpers/Url/Url';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';
import config from '@plone/volto/registry';

/**
 * Customization do bloco Image (Volto core) — adiciona suporte a caption.
 * Quando data.caption está preenchido, envolvemos a img numa <figure>
 * e renderizamos <figcaption>. Sem caption, o output é idêntico ao core.
 */
export const View = ({ className, data, detached, properties, style }) => {
  const href = data?.href?.[0]?.['@id'] || '';
  const Image = config.getComponent({ name: 'Image' }).component;

  if (!data.url) {
    return (
      <p
        className={cx(
          'block image align',
          { center: !Boolean(data.align), detached },
          data.align,
          className,
        )}
        style={style}
      />
    );
  }

  const image = (
    <Image
      className={cx({
        'full-width': data.align === 'full',
        large: data.size === 'l',
        medium: data.size === 'm',
        small: data.size === 's',
      })}
      item={
        data.image_scales
          ? {
              '@id': data.url,
              image_field: data.image_field,
              image_scales: data.image_scales,
            }
          : undefined
      }
      src={
        data.image_scales
          ? undefined
          : isInternalURL(data.url)
            ? (() => {
                if (data.size === 'l')
                  return `${flattenToAppURL(data.url)}/@@images/image`;
                if (data.size === 'm')
                  return `${flattenToAppURL(data.url)}/@@images/image/preview`;
                if (data.size === 's')
                  return `${flattenToAppURL(data.url)}/@@images/image/mini`;
                return `${flattenToAppURL(data.url)}/@@images/image`;
              })()
            : data.url
      }
      sizes={config.blocks.blocksConfig.image.getSizes(data)}
      alt={data.alt || ''}
      loading="lazy"
      responsive={true}
    />
  );

  const imageOrLink = href ? (
    <UniversalLink href={href} openLinkInNewTab={data.openLinkInNewTab}>
      {image}
    </UniversalLink>
  ) : (
    image
  );

  const wrapperClassName = cx(
    'block image align',
    { center: !Boolean(data.align), detached },
    data.align,
    className,
  );

  if (data.caption) {
    return (
      <figure className={wrapperClassName} style={style}>
        {imageOrLink}
        <figcaption className="ag-image-block__caption">{data.caption}</figcaption>
      </figure>
    );
  }

  return (
    <p className={wrapperClassName} style={style}>
      {imageOrLink}
    </p>
  );
};

View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default withBlockExtensions(View);
